import React from "react";
import { Route , Redirect } from "react-router-dom" ;
import {store} from '../helper/store';
import cookie from "react-cookies";
import { globalUrlPrefix } from '../utils/const'

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route 
        {...rest} 
        render = { props => {
            if (store.getState().loginAlerts.status === true || cookie.loadAll().token !== undefined) {
                return <Component {...props} />
            } else {
                return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
            }
    }} />
);

export const LoginRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => ( store.getState().loginAlerts.status === true || cookie.loadAll().token !== undefined
            ? <Redirect to={{ pathname: '/' + globalUrlPrefix + '/dashboard', state: { from: props.location } }} />
            : <Component {...props} />
    )} />
);


const unsubscribe = store.subscribe(PrivateRoute)
unsubscribe()
